<template>
   <div class="acc-page-container sub-page-wrapper">
      <Aside />
      <Main>
         <Navbar />
         <div class="container-fluid">
            <div class="row">
               <div class="col gts-box mx-3">
                  <h1 class="sub-page-header">{{ $t("accountTransactionList_title") }}</h1>
                  <div class="sub-page-row-wrapper row gy-3">
                     <div class="col-12 col-md-6 col-lg-2">
                        <UIDatePicker2
                           :key="$i18n.locale"
                           :label="$t('accountTransactionList_filter_lblFromDate')"
                           :min="searchQuery.date1.min"
                           :max="searchQuery.date1.max"
                           v-model="searchQuery.date1.value" />
                     </div>
                     <div class="col-12 col-md-6 col-lg-2">
                        <UIDatePicker2
                           :key="$i18n.locale"
                           :label="$t('accountTransactionList_filter_lblToDate')"
                           :min="searchQuery.date1.min"
                           :max="searchQuery.date2.max"
                           v-model="searchQuery.date2.value" />
                     </div>
                  </div>
                  <!--  CTA -->
                  <div class="sub-page-actions-row row">
                     <div class="sub-pages-actions-wrapper col-12">
                        <UIButton className="default" :text="$t('accountTransactionList_filter_btnList')" @click.native="listTransactions(false)" />
                     </div>
                  </div>
               </div>
            </div>
            <div class="page-inner">
               <section class="page-section gts-box" v-if="currentTableOptions.rows.length > 0">
                  <GtsGrid id="mainTable" :table-options="currentTableOptions" :item-per-page="-1" :title="$t('accountTransactionList_tblMain_title')" />
               </section>
               <section ref="sectionSummary" class="page-section gts-box" v-if="currentSummaryTableOptions.rows.length > 0">
                  <GtsGrid id="summaryTable" :table-options="currentSummaryTableOptions" :item-per-page="-1" :title="$t('accountTransactionList_tblSumm_title')" />
               </section>
            </div>
         </div>
      </Main>
   </div>
</template>

<script>
import moment from "moment";
import Popup from "@/gts-popup.js";
import Main from "@/components/unitary/Main.vue";
import Aside from "@/components/unitary/Aside.vue";
import { financeService } from "@/service/index.js";
import Navbar from "@/components/unitary/Navbar.vue";
import GtsGrid from "@/components/utils/GtsGrid.vue";
import UIButton from "@/components/unitary/Button.vue";
import UIDatePicker2 from "@/components/unitary/form2/UIDatePicker2.vue";

export default {
   name: "AccTransactionList",
   components: {
      Main,
      Aside,
      Navbar,
      GtsGrid,
      UIButton,
      UIDatePicker2,
   },
   data() {
      return {
         searchQuery: {
            date1: {
               min: moment().subtract(1, "year").startOf("year").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().format(this.$constants.dateFormat),
            },
            date2: {
               min: moment().subtract(1, "year").startOf("year").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().format(this.$constants.dateFormat),
            },
         },
         tableOptions: {
            columns: [],
            rows: [],
         },
         summaryTableOptions: {
            columns: [],
            rows: [],
         },
      };
   },
   computed: {
      tableColumns() {
         return [
            { label: this.$t("accountTransactionList_tblMain_thDebt") },
            { label: this.$t("accountTransactionList_tblMain_thCredit") },
            { label: this.$t("accountTransactionList_tblMain_thBalance") },
            { label: this.$t("accountTransactionList_tblMain_thCurrency") },
            { label: this.$t("accountTransactionList_tblMain_thDate") },
            { label: this.$t("accountTransactionList_tblMain_thTrxType") },
            { label: this.$t("accountTransactionList_tblMain_thInfo") },
            { label: this.$t("accountTransactionList_tblMain_thOrderId") },
            { label: this.$t("accountTransactionList_tblMain_thEntity") },
            { label: this.$t("accountTransactionList_tblMain_thProvider") },
            { label: this.$t("accountTransactionList_tblMain_thUserEmail") },
         ];
      },
      currentTableOptions() {
         return { ...this.tableOptions, columns: this.tableColumns };
      },
      summaryTableColumns() {
         return [
            { label: this.$t("accountTransactionList_tblSumm_thTrxType") },
            { label: this.$t("accountTransactionList_tblSumm_thDebt") },
            { label: this.$t("accountTransactionList_tblSumm_thCredit") },
            { label: this.$t("accountTransactionList_tblSumm_thBalance") },
            { label: this.$t("accountTransactionList_tblMain_thCurrency") },
         ];
      },
      currentSummaryTableOptions() {
         return { ...this.summaryTableOptions, columns: this.summaryTableColumns };
      },
   },
   methods: {
      listTransactions(scrollToSummary) {
         this.tableOptions.rows = [];
         this.summaryTableOptions.rows = [];

         this.$store.commit("app/setIsProgressGifActive", true);

         const request = {
            date1: this.searchQuery.date1.value,
            date2: this.searchQuery.date2.value,
         };

         financeService
            .listTransactions(request)
            .then((res) => {
               if (!res.result.success) {
                  res.result.service = this.$options.name;
                  Popup.result(res.result);
                  return;
               }

               if (res.result.success) {
                  this.$store.commit("app/setIsProgressGifActive", false);
                  //HEADER_ROW
                  this.tableOptions.rows.push({
                     debt: "",
                     credit: "",
                     balance: {
                        iteration: [this.$options.filters.price(res.balanceBegin, res.currency)],
                        className: "is-price",
                        filter: "price",
                     },
                     datetime: "",
                     trxType: {
                        iteration: [this.$t("accountTransactionList_tblMain_thBalanceBegin")],
                        className: "txt-black",
                     },
                     info: "",
                     orderId: "",
                     entity: "",
                     provider: "",
                     userEmail: "",
                     tags: "",
                  });

                  //MAIN_TABLE
                  res.trxes.map((trx) => {
                     const rowObj = {
                        debt: {
                           iteration: [this.$options.filters.price(trx.debt, false)],
                           className: "is-price",
                        },
                        credit: {
                           iteration: [this.$options.filters.price(trx.credit, false)],
                           className: "is-price",
                        },
                        balance: {
                           iteration: [this.$options.filters.price(trx.balance, false)],
                           className: "is-price",
                        },
                        currency: trx.currency,

                        datetime: this.$options.filters.FormatterDateTime(trx.datetime),
                        trxType: {
                           iteration: [this.$t("EAccTransactionTypeGroup_" + trx.trxType)],
                        },
                        info: trx.info,
                        orderId:
                           trx.orderId <= 0
                              ? ""
                              : {
                                   iteration: [trx.orderId],
                                   className: "order-router gts-animation-scale",
                                   router: `/order/detail/${trx.orderUuid}`,
                                },
                        entity: trx.entity,
                        provider: trx.entityType == 3 ? (trx.channelOnUs && trx.channelOnUsContract ? trx.provider : this.$t("accountTransactionList_tblMain_trProvider")) : trx.provider,
                        userEmail: trx.userEmail,
                        tags: JSON.stringify(trx),
                     };
                     this.tableOptions.rows.push(rowObj);
                  });

                  //FOOTER_ROW_1
                  this.tableOptions.rows.push({
                     debt: "",
                     credit: "",
                     balance: {
                        iteration: [res.balanceEnd],
                        className: "is-price",
                        filter: "price",
                     },
                     datetime: "",
                     trxType: {
                        iteration: [this.$t("accountTransactionList_tblMain_thBalanceEnd")],
                        className: "txt-black",
                     },
                     info: "",
                     orderId: "",
                     entity: "",
                     provider: "",
                     userEmail: "",
                     tags: "",
                  });

                  //FOOTER_ROW_2
                  this.tableOptions.rows.push({
                     debt: {
                        iteration: [this.$options.filters.price(res.trxDebt, false)],
                        className: "is-price",
                        filter: "price",
                     },
                     credit: {
                        iteration: [this.$options.filters.price(res.trxCredit, false)],
                        className: "is-price",
                        filter: "price",
                     },
                     balance: {
                        iteration: [this.$options.filters.price(res.balanceTrx, false)],
                        className: "is-price",
                        filter: "price",
                     },
                     datetime: "",
                     trxType: {
                        iteration: [this.$t("accountTransactionList_tblMain_thTrxSum")],
                        className: "txt-black",
                     },
                     info: "",
                     orderId: "",
                     entity: "",
                     provider: "",
                     userEmail: "",
                     tags: "",
                  });

                  //SUMMARY_TABLE
                  Object.keys(res.summary).forEach((key) => {
                     let item = res.summary[key];
                     const summaryRowObj = {
                        trxType: {
                           iteration: [this.$t("EAccTransactionTypeGroup_" + item.trxType)],
                        },
                        debt: {
                           iteration: [item.debt],
                           className: "is-price",
                        },
                        credit: {
                           iteration: [item.credit],
                           className: "is-price",
                        },
                        balance: {
                           iteration: [item.balance],
                           className: "is-price",
                        },
                        currency: item.currency,
                        tags: JSON.stringify(item),
                     };
                     this.summaryTableOptions.rows.push(summaryRowObj);
                  });
               }
            })
            .then(() => {
               if (scrollToSummary) this.$refs.sectionSummary.scrollIntoView({ behavior: "smooth" });
            });
      },
   },
   created() {
      if (this.$route.query.deposit) {
         this.listTransactions(true);
      }
   },
};
</script>

<style lang="scss" scoped>
.page-container {
   .page-inner {
      width: 90%;
      margin: auto;
      .page-form-row {
         display: grid;
         grid-template-columns: repeat(6, 1fr);
         grid-column-gap: 1rem;
      }
      .page-action-row {
         margin-top: 1rem;
         display: flex;
         justify-content: flex-end;
      }
   }
}
</style>
